var map = {
	"./empty.png": 41550,
	"./failed_load.png": 49822,
	"./no-data-white.png": 11972,
	"./no-data.png": 98339,
	"./no-net.png": 12067,
	"./no_message.png": 82265,
	"./no_orders.png": 80538,
	"./no_results_found.png": 80350,
	"./null-image.png": 69128,
	"./null_bg.png": 12757
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85185;